import { Link } from "react-router-dom";
import Logo from "./Logo";
import { NetworkHero } from "./Illustrations";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function googleLogin() {
  const redirectUrl = window.location.origin + "/app";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      {/* Left: brand panel */}
      <div className="relative hidden overflow-hidden bg-[color:var(--invert-bg)] lg:block">
        <div className="grid-lines absolute inset-0 opacity-30" />
        <div className="relative z-10 flex h-full flex-col justify-between p-12">
          <Logo variant="light" />
          <div>
            <NetworkHero className="mb-10 w-full max-w-md" />
            <h2 className="font-display max-w-md text-3xl font-semibold leading-tight tracking-tight text-white">
              One place where businesses grow together.
            </h2>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
              Join founders, businesses, professionals, investors and growth
              partners inside the StUpEco business growth network.
            </p>
          </div>
          <p className="text-xs text-white/40">© {new Date().getFullYear()} StUpEco Hub</p>
        </div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center px-5 py-12 sm:px-10">
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden">
            <Logo />
          </div>
          <h1 className="font-display text-3xl font-semibold tracking-[-0.02em] text-[color:var(--ink)] sm:text-4xl">
            {title}
          </h1>
          {subtitle && <p className="mt-3 text-[color:var(--ink-soft)]">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-[color:var(--ink-soft)]">{footer}</div>}
          <p className="mt-10 text-center text-xs text-[color:var(--ink-soft)]">
            <Link to="/" className="hover:text-[color:var(--ink)]">← Back to StUpEco Hub</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
